(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-catalogue"] && !Shopify.designMode) return;
  try {
    
  class V2Catalogue extends HTMLElement {
    #abort = new AbortController();
    #groups = ['colour', 'style'];

    connectedCallback() {
      const signal = this.#abort.signal;
      this.form = this.querySelector('form');
      this.items = [...this.querySelectorAll('.v2-cat__item')];
      this.countEl = this.querySelector('[data-count]');
      this.mirror = this.querySelector('[data-count-mirror]');
      this.badge = this.querySelector('[data-active-count]');
      this.showLabel = this.querySelector('[data-show-label]');
      this.empty = this.querySelector('[data-empty]');
      this.openBtn = this.querySelector('.v2-cat__open');
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

      const hero = document.querySelector('.v2-chero');
      this.heroTitle = hero?.querySelector('.v2-chero__title') || null;
      this.heroDesc = hero?.querySelector('.v2-chero__desc') || null;
      this.heroSets = [...(hero?.querySelectorAll('.v2-chero__set[data-colour]') || [])];
      this.baseTheme = hero?.dataset.baseTheme || 'paper';
      this.origTitleHTML = this.heroTitle?.innerHTML || '';
      this.origDesc = this.heroDesc?.textContent || '';
      this.origDocTitle = document.title;
      this.touched = false;

      this.#readUrl();
      this.apply(false);

      this.form.addEventListener(
        'change',
        () => {
          this.touched = true;
          this.apply(true);
        },
        { signal }
      );

      // Single-select groups: clicking the active radio again clears that group.
      this.form.addEventListener(
        'pointerdown',
        (e) => {
          const label = e.target instanceof Element ? e.target.closest('label') : null;
          const input = label?.querySelector('input[type="radio"]');
          if (input) input.dataset.was = String(input.checked);
        },
        { signal }
      );
      this.form.addEventListener(
        'click',
        (e) => {
          const input = e.target;
          if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
          if (input.dataset.was === 'true') {
            input.checked = false;
            this.touched = true;
            this.apply(true);
          }
          input.dataset.was = 'false';
        },
        { signal }
      );
      // Phone colourway row: toggles the matching colour radio, so it behaves exactly like the sheet.
      this.quickChips = [...this.querySelectorAll('[data-quick-colour]')];
      for (const chip of this.quickChips) {
        chip.addEventListener(
          'click',
          () => {
            const input = this.form.querySelector(`input[name="colour"][value="${CSS.escape(chip.dataset.quickColour || '')}"]`);
            if (!(input instanceof HTMLInputElement)) return;
            input.checked = !input.checked;
            this.touched = true;
            this.apply(true);
          },
          { signal }
        );
      }
      for (const b of this.querySelectorAll('[data-clear]')) b.addEventListener('click', () => this.clear(), { signal });
      this.openBtn?.addEventListener('click', () => this.open(), { signal });
      for (const b of this.querySelectorAll('[data-close]')) b.addEventListener('click', () => this.close(), { signal });
      this.addEventListener('keydown', (e) => this.#onKey(e), { signal });
    }

    disconnectedCallback() {
      this.#abort.abort();
    }

    /** URL params override the collection's own pre-selection. */
    #readUrl() {
      const params = new URLSearchParams(location.search);
      const touched = [...this.#groups, 'sets'].some((g) => params.has(g));
      if (!touched) return;
      this.touched = true;
      for (const input of this.form.querySelectorAll('input')) input.checked = false;
      for (const g of this.#groups) {
        const value = (params.get(g) || '').split(',')[0].trim();
        if (!value) continue;
        const input = this.form.querySelector(`input[name="${g}"][value="${CSS.escape(value)}"]`);
        if (input) input.checked = true;
      }
      const sets = this.form.querySelector('input[name="sets"]');
      if (sets) sets.checked = params.get('sets') === '1';
    }

    #selected() {
      const sel = {};
      for (const g of this.#groups) {
        sel[g] = [...this.form.querySelectorAll(`input[name="${g}"]:checked`)].map((i) => i.value);
      }
      sel.sets = Boolean(this.form.querySelector('input[name="sets"]:checked'));
      return sel;
    }

    /** @param {boolean} animate */
    apply(animate) {
      const sel = this.#selected();
      const before = new Map();
      const canAnimate = animate && !this.reduce.matches;
      if (canAnimate) for (const el of this.items) if (!el.hidden) before.set(el, el.getBoundingClientRect());

      let count = 0;
      for (const el of this.items) {
        const d = el.dataset;
        const ok =
          (!sel.colour.length || sel.colour.includes(d.colour)) &&
          (!sel.style.length || sel.style.some((v) => (d.style || '').split(' ').includes(v))) &&
          (!sel.sets || d.set === '1');
        el.hidden = !ok;
        if (ok) count++;
      }

      if (canAnimate) {
        for (const el of this.items) {
          if (el.hidden) continue;
          const first = before.get(el);
          if (!first) {
            el.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], {
              duration: 250,
              easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
            });
            continue;
          }
          const last = el.getBoundingClientRect();
          const dx = first.left - last.left;
          const dy = first.top - last.top;
          if (dx || dy) {
            el.animate([{ transform: `translate(${dx}px, ${dy}px)` }, { transform: 'none' }], {
              duration: 250,
              easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
            });
          }
        }
      }

      const one = count === 1;
      const label = String((one ? this.dataset.countOne : this.dataset.countOther) || '').replace('__N__', String(count));
      const show = String((one ? this.dataset.showOne : this.dataset.showOther) || '').replace('__N__', String(count));
      if (this.countEl) this.countEl.textContent = label;
      if (this.mirror) this.mirror.textContent = label;
      if (this.showLabel) this.showLabel.textContent = show;
      if (this.empty) this.empty.hidden = count > 0;
      const active = sel.colour.length + sel.style.length + (sel.sets ? 1 : 0);
      if (this.badge) {
        this.badge.hidden = active === 0;
        this.badge.textContent = String(active);
      }
      for (const chip of this.quickChips || []) {
        chip.setAttribute('aria-pressed', String(sel.colour.includes(chip.dataset.quickColour || '')));
      }
      this.#syncHero(sel);
      if (animate) this.#writeUrl(sel);
    }

    /** The header follows the selection: ground colour, heading, intro, page title, set promo. */
    #syncHero(sel) {
      const hero = document.querySelector('.v2-chero');
      if (!hero) return;
      const colour = sel.colour[0] || '';
      for (const c of [...hero.classList]) if (c.startsWith('v2-theme--')) hero.classList.remove(c);
      hero.classList.add(`v2-theme--${colour || this.baseTheme}`);
      if (!this.touched || !this.heroTitle) return;

      const colourInput = colour ? this.form.querySelector(`input[name="colour"][value="${CSS.escape(colour)}"]`) : null;
      const styleInput = sel.style[0] ? this.form.querySelector(`input[name="style"][value="${CSS.escape(sel.style[0])}"]`) : null;
      const colourName = colourInput?.dataset.name || '';
      const styleName = styleInput?.dataset.name || '';
      const esc = (t) => t.replace(/[&<>"]/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[ch]);
      const fallback = sel.sets ? this.dataset.setsTitle || 'Sets of 3' : this.dataset.allTitle || 'Shop all';
      let html;
      let plain;
      if (colourName && styleName) {
        html = `${esc(colourName)} · <em>${esc(styleName)}</em>`;
        plain = `${colourName} · ${styleName}`;
      } else {
        plain = colourName || styleName || fallback;
        html = esc(plain);
      }

      if (this.heroTitle.innerHTML !== html) {
        if (this.reduce.matches) {
          this.heroTitle.innerHTML = html;
        } else {
          const out = this.heroTitle.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 120, easing: 'ease-out' });
          out.onfinish = () => {
            this.heroTitle.innerHTML = html;
            this.heroTitle.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 130, easing: 'ease-out' });
          };
        }
      }

      const sep = this.origDocTitle.match(/\s[–—|-]\s/);
      document.title = sep ? plain + this.origDocTitle.slice(this.origDocTitle.indexOf(sep[0])) : plain;

      if (this.heroDesc) {
        const text = colour === this.baseTheme ? this.origDesc : colourInput?.dataset.desc || '';
        this.heroDesc.textContent = text;
        this.heroDesc.hidden = !text;
      }
      // Set promo follows the colour (none when no colour is chosen), crossfading in.
      for (const card of this.heroSets) {
        const show = card.dataset.colour === colour;
        if (show === !card.hidden) continue;
        card.hidden = !show;
        if (show && !this.reduce.matches) {
          card.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 250, easing: 'ease-out' });
        }
      }
    }

    #writeUrl(sel) {
      const url = new URL(location.href);
      for (const g of [...this.#groups, 'sets']) url.searchParams.delete(g);
      for (const g of this.#groups) if (sel[g].length) url.searchParams.set(g, sel[g][0]);
      if (sel.sets) url.searchParams.set('sets', '1');
      history.replaceState(history.state, '', url);
    }

    clear() {
      this.touched = true;
      for (const input of this.form.querySelectorAll('input')) input.checked = false;
      this.apply(true);
    }

    open() {
      this.lastFocus = document.activeElement;
      this.setAttribute('data-open', '');
      const scrim = this.querySelector('.v2-cat__scrim');
      if (scrim) scrim.hidden = false;
      this.form.setAttribute('role', 'dialog');
      this.form.setAttribute('aria-modal', 'true');
      this.openBtn?.setAttribute('aria-expanded', 'true');
      document.documentElement.setAttribute('scroll-lock', '');
      requestAnimationFrame(() => this.form.querySelector('input')?.focus());
    }

    close() {
      if (!this.hasAttribute('data-open')) return;
      this.removeAttribute('data-open');
      this.form.removeAttribute('role');
      this.form.removeAttribute('aria-modal');
      this.openBtn?.setAttribute('aria-expanded', 'false');
      document.documentElement.removeAttribute('scroll-lock');
      const scrim = this.querySelector('.v2-cat__scrim');
      setTimeout(() => {
        if (scrim && !this.hasAttribute('data-open')) scrim.hidden = true;
      }, 300);
      if (this.lastFocus instanceof HTMLElement) this.lastFocus.focus();
    }

    /** @param {KeyboardEvent} e */
    #onKey(e) {
      if (!this.hasAttribute('data-open')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        this.close();
        return;
      }
      if (e.key !== 'Tab') return;
      const focusables = [...this.form.querySelectorAll('input, button')].filter((el) => el.offsetParent !== null);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  if (!customElements.get('v2-catalogue')) customElements.define('v2-catalogue', V2Catalogue);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-formats"] && !Shopify.designMode) return;
  try {
    
  class V2FmtTabs extends HTMLElement {
    #abort = new AbortController();

    connectedCallback() {
      const signal = this.#abort.signal;
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      for (const tab of this.tabs) {
        tab.addEventListener('click', () => this.select(tab), { signal });
        tab.addEventListener('keydown', (e) => this.#onKey(e, tab), { signal });
      }
    }

    disconnectedCallback() {
      this.#abort.abort();
    }

    /** @param {HTMLElement} tab @param {boolean} [focus] */
    select(tab, focus = false) {
      const id = tab.dataset.panel;
      for (const t of this.tabs) {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
      }
      for (const img of this.querySelectorAll('img[data-panel]')) {
        const on = img.dataset.panel === id;
        if (on && img.loading === 'lazy') img.loading = 'eager';
        img.classList.toggle('is-on', on);
      }
      for (const note of this.querySelectorAll('.v2-fmt__note')) note.hidden = note.dataset.panel !== id;
      if (focus) tab.focus();
    }

    /** @param {KeyboardEvent} e @param {HTMLElement} tab */
    #onKey(e, tab) {
      const i = this.tabs.indexOf(tab);
      const n = this.tabs.length;
      const map = { ArrowRight: i + 1, ArrowDown: i + 1, ArrowLeft: i - 1, ArrowUp: i - 1, Home: 0, End: n - 1 };
      if (!(e.key in map)) return;
      e.preventDefault();
      this.select(this.tabs[(map[e.key] + n) % n], true);
    }
  }

  if (!customElements.get('v2-fmt-tabs')) customElements.define('v2-fmt-tabs', V2FmtTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-hero"] && !Shopify.designMode) return;
  try {
    
  /** Shows the phone sticky shop button once the hero is scrolled past, while neither the (optional) watched section nor the footer is on screen. */
  class V2StickyShop extends HTMLElement {
    #observer = null;

    connectedCallback() {
      const hero = this.previousElementSibling?.classList.contains('v2-hero') ? this.previousElementSibling : document.querySelector('.v2-hero');
      if (!hero || !('IntersectionObserver' in window)) return;
      const watch = this.dataset.watch ? document.getElementById(this.dataset.watch) : null;
      const footer = document.querySelector('.v2-footer');
      const state = { heroPassed: false, watchVisible: false, footerVisible: false };

      this.#observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.target === hero) state.heroPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          else if (entry.target === watch) state.watchVisible = entry.isIntersecting;
          else if (entry.target === footer) state.footerVisible = entry.isIntersecting;
        }
        const show = state.heroPassed && !state.watchVisible && !state.footerVisible;
        this.toggleAttribute('data-show', show);
        this.inert = !show;
      });
      for (const target of [hero, watch, footer]) if (target) this.#observer.observe(target);
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
      this.#observer = null;
    }
  }

  if (!customElements.get('v2-sticky-shop')) customElements.define('v2-sticky-shop', V2StickyShop);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-swatch-row"] && !Shopify.designMode) return;
  try {
    
  class V2ColourTabs extends HTMLElement {
    #abort = new AbortController();

    connectedCallback() {
      const signal = this.#abort.signal;
      this.section = this.closest('.v2-colours');
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      for (const tab of this.tabs) {
        tab.addEventListener('click', () => this.select(tab), { signal });
        tab.addEventListener('keydown', (event) => this.#onKey(event, tab), { signal });
      }
      this.#watchImages(this);
      const preload = () => {
        for (const img of this.querySelectorAll('[role="tabpanel"][hidden] img[loading="lazy"]')) img.loading = 'eager';
      };
      if (document.readyState === 'complete') this.#idle(preload);
      else window.addEventListener('load', () => this.#idle(preload), { once: true, signal });
    }

    disconnectedCallback() {
      this.#abort.abort();
    }

    /** @param {HTMLElement} tab */
    select(tab, focus = false) {
      if (tab.getAttribute('aria-selected') === 'true') return;
      for (const t of this.tabs) {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const panel = this.querySelector(`#${t.getAttribute('aria-controls')}`);
        if (!panel) continue;
        panel.hidden = !on;
        panel.classList.toggle('is-entering', on);
        if (on) panel.addEventListener('animationend', () => panel.classList.remove('is-entering'), { once: true });
      }
      if (this.section) {
        for (const c of [...this.section.classList]) if (c.startsWith('v2-theme--')) this.section.classList.remove(c);
        this.section.classList.add(`v2-theme--${tab.dataset.theme || 'paper'}`);
      }
      if (focus) tab.focus();
    }

    /** @param {KeyboardEvent} event @param {HTMLElement} tab */
    #onKey(event, tab) {
      const i = this.tabs.indexOf(tab);
      let next = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = this.tabs[(i + 1) % this.tabs.length];
      else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = this.tabs[(i - 1 + this.tabs.length) % this.tabs.length];
      else if (event.key === 'Home') next = this.tabs[0];
      else if (event.key === 'End') next = this.tabs[this.tabs.length - 1];
      if (!next) return;
      event.preventDefault();
      this.select(next, true);
    }

    /** @param {ParentNode} root */
    #watchImages(root) {
      for (const img of root.querySelectorAll('img.v2-fade')) {
        if (img.complete && img.naturalWidth) img.classList.add('is-loaded');
        else img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true, signal: this.#abort.signal });
      }
    }

    /** @param {() => void} fn */
    #idle(fn) {
      if ('requestIdleCallback' in window) window.requestIdleCallback(fn, { timeout: 2500 });
      else setTimeout(fn, 1200);
    }
  }

  if (!customElements.get('v2-colour-tabs')) customElements.define('v2-colour-tabs', V2ColourTabs);

  } catch(e) { console.error(e); }
})();
})();
